import React, {useState} from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import { IsEmptyString } from "../GeneralFunctions"

const DatasourceAutoflex = (props) => {

    const [mRepainter, SetRepainter] = useState(false); 

    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue
        SetRepainter(!mRepainter)

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(!IsEmptyString(props.IntegrationSettings.DatasourceSettings["Username"]) && !IsEmptyString(props.IntegrationSettings.DatasourceSettings["Password"]))
    }

    return (
        <div className="scriptitembody">
            <div className="wizardfieldname">{Translate("Username").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings["Username"] || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Username")} className="wizardinputfield"/></div>
            <div className="wizardfieldname">{Translate("Password").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="new-password" type="password" value={props.IntegrationSettings.DatasourceSettings["Password"] || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Password")} className="wizardinputfield"/></div>
            <br/>
            <table cellPadding="2">
            <tbody>
                <tr>
                    <td width="30"><span className="checkbox-wrapper-13"><input type="checkbox" checked={props.IntegrationSettings.DatasourceSettings.TestEnvironment ? "checked" : ""} onChange={evt => UpdateDatasourceSetting(evt.target.checked, "TestEnvironment")}/></span></td>
                    <td width="*">{Translate("Test environment")}</td>
                </tr>
            </tbody>
            </table>
        </div>
    );
}

DatasourceAutoflex.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceAutoflex